// editarpedido.jsx
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import '../Empresas/formulario.css';

import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import PedidoForm from "../Components/PedidoForm/PedidoForm";
import { useAuth } from "../Context/auth";
import '../Pedidos/Pedidos.css';

function EditarPedido() {
    const { currentUser, tenantId } = useAuth();  // <-- ADICIONADO tenantData
    const { id: pedidoId } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [mensagem, setMensagem] = useState('');
    const [initialData, setInitialData] = useState(null);

    const [planoTenant, setPlanoTenant] = useState(null)


    // ================== FUNÇÃO DE IMPRESSÃO (RESUMO) ==================
    const handleImprimirPedido = useCallback(async () => {
        setLoading(true);
        setMensagem('Gerando PDF do Resumo do pedido...');
        try {
            if (!currentUser || !pedidoId) {
                throw new Error("Usuário ou ID do pedido inválido.");
            }
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;

            // Rota original para o Resumo
            const response = await fetch(`${API_URL}/api/pedidos/${pedidoId}/imprimir`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!response.ok) {
                const errData = await response.json().catch(() => ({ error: "Falha ao gerar PDF." }));
                throw new Error(errData.error);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            window.open(url);
            setMensagem('');

        } catch (error) {
            console.error("Erro ao gerar PDF do Pedido:", error);
            setMensagem(error.message);
            Swal.fire('Erro', error.message, 'error');
        } finally {
            setLoading(false);
        }
    }, [currentUser, pedidoId]);

    // ================== NOVA FUNÇÃO DE IMPRESSÃO (ROMANEIO) ==================
    const handleImprimirRomaneio = useCallback(async () => {
        setLoading(true);
        setMensagem('Gerando PDF das Etiquetas de Romaneio...');
        try {
            if (!currentUser || !pedidoId) {
                throw new Error("Usuário ou ID do pedido inválido.");
            }
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;

            // Nova rota para as etiquetas
            const response = await fetch(`${API_URL}/api/pedidos/${pedidoId}/imprimir-romaneio`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!response.ok) {
                const errData = await response.json().catch(() => ({ error: "Falha ao gerar PDF das etiquetas." }));
                throw new Error(errData.error);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            window.open(url);
            setMensagem('');

        } catch (error) {
            console.error("Erro ao gerar PDF das Etiquetas:", error);
            setMensagem(error.message);
            Swal.fire('Erro', error.message, 'error');
        } finally {
            setLoading(false);
        }
    }, [currentUser, pedidoId]);
    // ================== FIM DA NOVA FUNÇÃO ==================

    // ================== NOVA FUNÇÃO DE IMPRESSÃO (RESUMO COM GRADE) ==================
    const handleImprimirResumoGrade = useCallback(async () => {
        setLoading(true);
        setMensagem('Gerando PDF do Resumo com Grade...');
        try {
            if (!currentUser || !pedidoId) throw new Error("Usuário ou ID inválido.");
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;

            const response = await fetch(`${API_URL}/api/pedidos/${pedidoId}/imprimir-resumo-grade`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (!response.ok) {
                const errData = await response.json().catch(() => ({ error: "Falha ao gerar PDF." }));
                throw new Error(errData.error);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            window.open(url);
            setMensagem('');
        } catch (error) {
            console.error("Erro ao gerar PDF:", error);
            setMensagem(error.message);
            Swal.fire('Erro', error.message, 'error');
        } finally {
            setLoading(false);
        }
    }, [currentUser, pedidoId]);


    useEffect(() => {
        if (!pedidoId || !currentUser) return;

        // 2. Renomeia a função para carregar TUDO
        const fetchDadosCombinados = async () => {
            setLoading(true);
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;

                // 3. Busca os dados do pedido E o contexto do usuário em paralelo
                const [pedidoResponse, userResponse] = await Promise.all([
                    fetch(`${API_URL}/api/pedidos/${pedidoId}`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    }),
                    fetch(`${API_URL}/api/user-context`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    })
                ]);

                if (!pedidoResponse.ok) {
                    throw new Error("Pedido não encontrado ou acesso negado.");
                }
                if (!userResponse.ok) {
                    throw new Error("Não foi possível carregar os dados do usuário.");
                }

                const pedidoData = await pedidoResponse.json();
                const userData = await userResponse.json();

                setInitialData(pedidoData);   // 4. Salva dados do pedido
                setPlanoTenant(userData.plano); // 5. Salva o plano

            } catch (error) {
                console.error("Erro ao buscar dados:", error);
                Swal.fire("Erro", error.message, "error");
                navigate('/app/pedidos');
            } finally {
                setLoading(false);
            }
        };

        fetchDadosCombinados();
    }, [pedidoId, currentUser, navigate]);


    async function handleAtualizarPedido(formData, options = {}) {
        // ... (código existente sem alteração) ...

        // CORREÇÃO: Se for silent save (stayOnPage), NÃO ativa o loading global para evitar unmount do form
        if (!options.stayOnPage) {
            setLoading(true);
        }

        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/pedidos/${pedidoId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Falha ao atualizar o pedido.");
            }

            // Sempre recarrega dados silenciosamente (comportamento Edit on Save)
            const [pedidoResponse] = await Promise.all([
                fetch(`${API_URL}/api/pedidos/${pedidoId}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                })
            ]);

            if (!pedidoResponse.ok) throw new Error("Erro ao recarregar dados do pedido.");
            const novoPedidoData = await pedidoResponse.json();

            setInitialData(novoPedidoData); // Atualiza estado local
            Swal.fire({
                title: 'Sucesso!',
                text: 'Pedido atualizado com sucesso.',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
            });
            // navigate('/app/pedidos'); // Removido
            return novoPedidoData;
        } catch (error) {
            Swal.fire("Erro", error.message, "error");
            console.error("Erro no update:", error);
            return null; // Não re-lança para evitar crash (tela branca/overlay) no React
        } finally {
            if (!options.stayOnPage) {
                setLoading(false);
            }
        }
    }



    if (loading || !initialData || !planoTenant) {
        // ... (código existente sem alteração) ...
        return (
            <div className="form-page-container" style={{ display: 'flex', paddingTop: 0 }}>
                <MenuLateral />
                <div className="content-with-sidebar">
                    <div className="loading-container-form">
                        <div className="loading-spinner"></div>
                        <p>Carregando dados do pedido...</p>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="form-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="page-header mb-2 d-flex justify-content-between align-items-center px-4">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/pedidos')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="page-title mb-0">Editar <span className="highlight">Pedido {initialData.numero}</span></h1>
                    </div>

                    {/* Botão de Imprimir movido para o cabeçalho */}
                    <div className="btn-group me-5">
                        <button
                            type="button"
                            className="btn btn-primary-custom dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={loading}
                        >
                            <i className="fas fa-print me-2"></i> Imprimir
                        </button>
                        <ul className="dropdown-menu dropdown-menu-end shadow">
                            <li>
                                <button className="dropdown-item" type="button" onClick={handleImprimirPedido}>
                                    Resumo do pedido
                                </button>
                            </li>
                            <li>
                                <button className="dropdown-item" type="button" onClick={handleImprimirResumoGrade}>
                                    Resumo com grade
                                </button>
                            </li>
                            <li>
                                <button className="dropdown-item" type="button" onClick={handleImprimirRomaneio}>
                                    Etiqueta de romaneio
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                {mensagem && <div className={`alert ${mensagem.includes('Gerando') ? 'alert-info' : 'alert-danger'} mx-4 mt-3`}>{mensagem}</div>}
                <div className="form-card-container px-4">
                    <PedidoForm
                        key={planoTenant}  // 🔑 força recriação ao mudar o plano
                        isEditing={true}
                        initialData={initialData}
                        onSubmit={handleAtualizarPedido}
                        loading={loading}
                        numeroPedido={initialData.numero}
                        tenantId={tenantId}
                        pedidoId={pedidoId}
                        onImprimirPedido={handleImprimirPedido}
                        onImprimirRomaneio={handleImprimirRomaneio}
                        plano={planoTenant}
                    />
                </div>
            </div>
        </div>
    );
}

export default EditarPedido;